export default __webpack_public_path__ + "static/media/heroimg.e6a03546.jpg";